"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mappers_1 = require("../products/mappers");
var address_utils_async_1 = require("../address-utils-async");
var buildBillingAddress = function (billingAddressDTO, instanceResolver) { return __awaiter(void 0, void 0, void 0, function () {
    var address, contactDetails, formattedAddress, billingAddress;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                address = billingAddressDTO && billingAddressDTO.address;
                if (!address) {
                    return [2 /*return*/, null];
                }
                contactDetails = billingAddressDTO.contactDetails;
                return [4 /*yield*/, address_utils_async_1.createPlatformizedWixCodeAddressObject(address, instanceResolver)];
            case 1:
                formattedAddress = _a.sent();
                billingAddress = {};
                if (contactDetails) {
                    billingAddress = {
                        firstName: contactDetails.firstName,
                        lastName: contactDetails.lastName,
                        email: contactDetails.email,
                        phone: contactDetails.phone,
                        company: contactDetails.company,
                        vatId: contactDetails.vatId && contactDetails.vatId.id,
                    };
                }
                billingAddress.address = formattedAddress;
                return [2 /*return*/, billingAddress];
        }
    });
}); };
function createFormattedPickupDetails(shippingInfoDTO, instanceResolver) {
    return __awaiter(this, void 0, void 0, function () {
        var address, buyerDetails, formattedAddress, pickupDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    address = shippingInfoDTO && shippingInfoDTO.pickupDetails && shippingInfoDTO.pickupDetails.pickupAddress;
                    if (!address) {
                        return [2 /*return*/, null];
                    }
                    buyerDetails = shippingInfoDTO.pickupDetails && shippingInfoDTO.pickupDetails.buyerDetails;
                    return [4 /*yield*/, address_utils_async_1.createPlatformizedWixCodeAddressObject(address, instanceResolver)];
                case 1:
                    formattedAddress = _a.sent();
                    pickupDetails = {};
                    if (buyerDetails) {
                        pickupDetails = {
                            firstName: buyerDetails.firstName,
                            lastName: buyerDetails.lastName,
                            email: buyerDetails.email,
                            phone: buyerDetails.phone,
                        };
                    }
                    pickupDetails.pickupAddress = formattedAddress;
                    return [2 /*return*/, pickupDetails];
            }
        });
    });
}
function createFormattedShippingAddress(shippingInfoDTO, instanceResolver) {
    return __awaiter(this, void 0, void 0, function () {
        var address, contactDetails, formattedAddress, shippingAddress;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    address = shippingInfoDTO && shippingInfoDTO.shippingAddress && shippingInfoDTO.shippingAddress.address;
                    if (!address) {
                        return [2 /*return*/, null];
                    }
                    contactDetails = shippingInfoDTO.shippingAddress.contactDetails;
                    return [4 /*yield*/, address_utils_async_1.createPlatformizedWixCodeAddressObject(address, instanceResolver)];
                case 1:
                    formattedAddress = _a.sent();
                    shippingAddress = {};
                    if (contactDetails) {
                        shippingAddress = {
                            firstName: contactDetails.firstName,
                            lastName: contactDetails.lastName,
                            email: contactDetails.email,
                            phone: contactDetails.phone,
                            company: contactDetails.company,
                            vatId: contactDetails.vatId && contactDetails.vatId.id,
                        };
                    }
                    shippingAddress.address = formattedAddress;
                    return [2 /*return*/, shippingAddress];
            }
        });
    });
}
var buildShippingInfo = function (shippingInfoDTO, instanceResolver) { return __awaiter(void 0, void 0, void 0, function () {
    var formattedPickupDetails, formattedShippingAddress, shippingInfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, createFormattedPickupDetails(shippingInfoDTO, instanceResolver)];
            case 1:
                formattedPickupDetails = _a.sent();
                return [4 /*yield*/, createFormattedShippingAddress(shippingInfoDTO, instanceResolver)];
            case 2:
                formattedShippingAddress = _a.sent();
                if (!formattedPickupDetails && !formattedShippingAddress) {
                    return [2 /*return*/, null];
                }
                shippingInfo = {};
                if (formattedShippingAddress) {
                    shippingInfo.shippingAddress = formattedShippingAddress;
                }
                if (formattedPickupDetails) {
                    shippingInfo.pickupDetails = formattedPickupDetails;
                }
                return [2 /*return*/, shippingInfo];
        }
    });
}); };
var buildLineItems = function (lineItems) {
    return (lineItems || []).map(function (lineItemDTO) {
        var mediaItem = null;
        if (lineItemDTO.mediaItem) {
            var fulMediaItem = {
                id: null,
                mediaType: lineItemDTO.mediaItem.mediaType,
                thumbnail: {
                    height: lineItemDTO.mediaItem.height,
                    url: lineItemDTO.mediaItem.url,
                    width: lineItemDTO.mediaItem.width,
                },
                title: '',
                image: {
                    height: lineItemDTO.mediaItem.height,
                    url: lineItemDTO.mediaItem.url,
                    width: lineItemDTO.mediaItem.width,
                },
            };
            mediaItem = {
                src: mappers_1.buildImageUrl(fulMediaItem),
                type: lineItemDTO.mediaItem.mediaType,
            };
        }
        return __assign(__assign({}, lineItemDTO), { mediaItem: mediaItem, price: getNumber(lineItemDTO.price), totalPrice: getNumber(lineItemDTO.totalPrice), weight: getNumber(lineItemDTO.weight) });
    });
};
var buildTotals = function (totals) {
    return {
        discount: getNumber(totals.discount),
        quantity: totals.quantity,
        shipping: getNumber(totals.shipping),
        subtotal: getNumber(totals.subtotal),
        tax: getNumber(totals.tax),
        total: getNumber(totals.total),
        weight: getNumber(totals.weight),
    };
};
var getNumber = function (string, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0; }
    var number = Number(string);
    return isNaN(number) ? defaultValue : number;
};
var buildCurrency = function (currency) {
    return {
        symbol: currency.symbol,
        code: currency.code,
    };
};
var buildBuyerInfo = function (buyerInfo) {
    return {
        email: buyerInfo.email,
        firstName: buyerInfo.firstName,
        identityType: buyerInfo.identityType,
        lastName: buyerInfo.lastName,
        phone: buyerInfo.phone,
    };
};
var buildAppliedCoupon = function (appliedCoupon) {
    return {
        code: appliedCoupon.code,
        couponType: appliedCoupon.couponType,
        discountValue: appliedCoupon.discountValue,
        name: appliedCoupon.name,
    };
};
exports.cartMapper = function (cartDTO, instanceResolver) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = {
                    _id: cartDTO.id,
                    status: cartDTO.status
                };
                if (!cartDTO.billingAddress) return [3 /*break*/, 2];
                return [4 /*yield*/, buildBillingAddress(cartDTO.billingAddress, instanceResolver)];
            case 1:
                _b = _d.sent();
                return [3 /*break*/, 3];
            case 2:
                _b = null;
                _d.label = 3;
            case 3:
                _a.billingAddress = _b,
                    _a.appliedCoupon = cartDTO.appliedCoupon ? buildAppliedCoupon(cartDTO.appliedCoupon) : null,
                    _a.buyerInfo = cartDTO.buyerInfo ? buildBuyerInfo(cartDTO.buyerInfo) : null,
                    _a.buyerNote = cartDTO.buyerNote,
                    _a.currency = cartDTO.currency ? buildCurrency(cartDTO.currency) : null,
                    _a.lineItems = cartDTO.lineItems ? buildLineItems(cartDTO.lineItems) : null;
                if (!cartDTO.shippingInfo) return [3 /*break*/, 5];
                return [4 /*yield*/, buildShippingInfo(cartDTO.shippingInfo, instanceResolver)];
            case 4:
                _c = _d.sent();
                return [3 /*break*/, 6];
            case 5:
                _c = null;
                _d.label = 6;
            case 6: return [2 /*return*/, (_a.shippingInfo = _c,
                    _a.totals = cartDTO.totals ? buildTotals(cartDTO.totals) : null,
                    _a.weightUnit = cartDTO.weightUnit,
                    _a)];
        }
    });
}); };
//# sourceMappingURL=cart.mapper.js.map